/*
 * Import common js to use common function in this javascript file
 */
import { deleteConfirmationAlert, commonClockTimepicker, commonDatepicker, select2Dropdown } from "./common";
import { searchByTableColumns } from "./common";




/**
 * Guest table listing
 */

var table = window.$('.enquiryTable').DataTable({
    "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
    "aLengthMenu": DATATABLE_MENU_LENGTH_OPTIONS,
    processing: true,
    serverSide: true,
    order: [
    ],
    "ajax": {
        "url": window.$(".enquiryTable").attr('link') + '?status=' + window.$('#enquiry_status_filter').val(),
        data: function (d) {
            d.status = $('#enquiry_status_filter').val()
        }
    },
    columns: [
        { data: 'id', name: 'id', "visible": false, },
        { data: 'status', name: 'status' },
        { data: 'date', name: 'date' },
        { data: 'time_slot', name: 'time_slot' },
        { data: 'guest_details', name: 'guest_details' },
        { data: 'no_of_guests', name: 'no_of_guests' },
        { data: 'guest_notes', name: 'guest_notes' },
        { data: 'action', name: 'action', orderable: false, searchable: false },
    ],
});
window.$(document).on('change', '#enquiry_status_filter ', function (e) {
    table.draw();
});

/**
 * Reservation store
 */
window.$(document).on('click', ".confirmReservation", function (e) {
    console.log(window.$(".enquiryUpdateForm").attr('store'))
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.confirmReservation').attr('disabled', 'disabled');
    window.axios({
        method: "post",
        url: window.$(".enquiryUpdateForm").attr('store'),
        data: window.$(".enquiryUpdateForm").serialize(),
    })
        .then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            if (window.$(".timeMatrixCalender").length !== 1) {
                setTimeout(function () {
                    window.location = response.data.redirectTo;
                }, 1000);
            } else {
                window.$('.closebtn').trigger('click');
                renderCalendar($("#lastRenderURL").val() + '?index=true&date=' + $("#visible_start").val() + '&area_id=' + window.$('#area').val());
            }

        })
        .catch(function (error) {
            window.$('.confirmReservation').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Enquiry update 
 */
window.$(".updateEnquiry").on('click', function (e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.updateEnquiry').attr('disabled', 'disabled');
    window.axios({
        method: "PUT",
        url: window.$(".enquiryUpdateForm").attr('action'),
        data: window.$(".enquiryUpdateForm").serialize(),
    })
        .then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function () {
                window.location = response.data.redirectTo;
            }, 1000);
        })
        .catch(function (error) {
            window.$('.updateEnquiry').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 401 || error.response.status == 403) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

// Populate slots for selected date
window.$(document).on('change', '.enquiryUpdateForm #enquiryDate', function (e) {

    window.axios({
        method: "post",
        url: window.$(".enquiryUpdateForm #enquiryDate").data('url'),
        data: window.$(".enquiryUpdateForm").serialize(),
    })
        .then(function (response) {
            window.$('#slots').html(response.data);
        })
        .catch(function (error) {
            if (error.response !== 'undefined' && error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            }
        });

});


// Populate combination tables dropdown for selected area
window.$(document).on('change', '.enquiryUpdateForm .get_available_tables', function (e) {
    // get available table
    getAvailableTable();
});
function getAvailableTable() {
    window.axios({
        method: "post",
        url: window.$(".enquiryUpdateForm #area_id").data('url'),
        data: window.$(".enquiryUpdateForm").serialize(),
    })
        .then(function (response) {
           window.$('#tablesSelectInput').html(`<label for="label-tables_id">Table <span>*</span></label>`+response.data);
            window.$('.enquiryUpdateForm .multi-selection').select2({
                placeholder: DROPDOWN_MULTI_SELECT_PLACEHOLDER,
                templateResult: formatOption
            });
        })
        .catch(function (error) {
            console.log(error);
            if (error.response !== 'undefined' && error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            }
        });
}
function formatOption(option) {
    var $option = $(
        '<div class="table-heading">' + option.text + '</div><small class="text-secondary ">' + option.title + '</small>'
    );
    return $option;
};


// Populate combination tables dropdown for selected cover
// window.$(document).on('change', '.enquiryUpdateForm #covers_id', function (e) {
//     var status = $('#status').val();
//     $('#status').val('');
//     window.axios({
//         method: "post",
//         url: window.$(".enquiryUpdateForm #covers_id").data('url'),
//         data: window.$(".enquiryUpdateForm").serialize(),
//     })
//         .then(function (response) {
//             $('#status').val(status);
//             $( "#tablesSelectInput" ).html('<label for="label-tables_id">Table <span>*</span></label>');
//             window.$('#tablesSelectInput').append(response.data);
//             window.$('.enquiryUpdateForm .multi-selection').select2({
//                 placeholder: DROPDOWN_MULTI_SELECT_PLACEHOLDER
//             });
//         })
//         .catch(function (error) {
//             $('#status').val(status);
//             if (error.response !== 'undefined' && error.response.status == 400) {
//                 window.$.each(error.response.data, function (key, value) {
//                     window.$('#' + key + '-error').text(value[0]);
//                 });
//             }
//         });

// });

// To show save enquiry or save and confirm reservation button
window.$(document).on('change', '.enquiryUpdateForm #status', function (e) {
    var status = window.$('.enquiryUpdateForm #status').val();
    if (status == 'accepted') {
        $(".confirmReservation").removeClass('d-none');
        $(".updateEnquiry").addClass('d-none');
    } else {
        $(".confirmReservation").addClass('d-none');
        $(".updateEnquiry").removeClass('d-none');
    }
    if (status == 'rejected') {
        $("#rejectNote").removeClass('d-none');
    } else {
        $("#rejectNote").addClass('d-none');
    }

});
window.addEventListener('DOMContentLoaded', (event) => {
	//     setTimeout(function(){
    //     if(window.$(".enquiryUpdateForm #area_id").val()){
    //     getAvailableTable();
    //     }
    // },1500)

    setTimeout(() => {
        window.$("#enquiryDate").datetimepicker({
            dayOfWeekStart: 1,
            timepicker: false,
            format: DATE_FORMAT,
            scrollYear: false,
            scrollMonth: false,
            scrollInput: false,
            onClose: function (dateText, inst) {
                // var date = moment(dateText).format(DATE_FORMAT_GUEST);
                // window.$(inst).val(date);
            },
            onChangeYear: function (dateText, inst) {
                var date = moment(dateText).format(DATE_FORMAT_GUEST);
                window.$(inst).val(date);
            },
            onChangeMonth: function (dateText, inst) {
                var date = moment(dateText).format(DATE_FORMAT_GUEST);
                window.$(inst).val(date);
            }
        });
    }, 1200);
});
window.$(document).ready(function () {
    var status = window.$('.enquiryUpdateForm #status').val();
    if (status == 'accepted') {
        $(".confirmReservation").removeClass('d-none');
        $(".updateEnquiry").addClass('d-none');
    } else {
        $(".confirmReservation").addClass('d-none');
        $(".updateEnquiry").removeClass('d-none');
    }
    // Setup - add a text input to each footer cell
    var excluded_columns = [7];
    searchByTableColumns(table, '.enquiryTable', excluded_columns);
});
window.$(document).ajaxComplete(function () {
    window.$('[data-toggle="tooltip"]').tooltip()
});
